export default __webpack_public_path__ + "static/gray_bg_02-c8bf258be6992ea9915edef351a68192.jpg";